import { useAuth0 } from "@auth0/auth0-react"
import { Input, Message } from "semantic-ui-react"
import { isSuperAdmin } from "../../../../../../Utils/util"

const UpgradeFirmwareModalContent = ({ setVersion, isInvalidVersion, invalidateVersionMessage, device, showErrorMessage, latestFirmwareVersion }) => {
	const { user } = useAuth0()

	return isSuperAdmin(user) ? (
		<>
			{showErrorMessage && (
				<Message negative>
					<p>Something unexpected happened</p>
				</Message>
			)}
			<>
				<Message color={isInvalidVersion ? "red" : "blue"}>
					{invalidateVersionMessage ? (
						<>
							{invalidateVersionMessage} <br />
							Please correct the firmware version
						</>
					) : (
						<>
							Please input the firmware version <br />
							If you want to push the latest version, please input "latest"
						</>
					)}
				</Message>
				<Message color={"grey"}>Current firmware version: {device.firmware ? device.firmware.toString() : "Unknown"}</Message>
			</>

			<Input placeholder="Please input the firmware version" error={isInvalidVersion} style={{ width: "100%" }} onChange={(e) => setVersion(e.target.value)} />
		</>
	) : (
		<>
			{showErrorMessage && (
				<Message negative>
					<p>Something unexpected happened</p>
				</Message>
			)}
			<p style={{ color: "black" }}>
				Are you sure you want to update <b>{device.shortname}</b> to <b>{latestFirmwareVersion}</b>?
			</p>
		</>
	)
}

export default UpgradeFirmwareModalContent
